export default "__VITE_ASSET__53b99a0b__"